import { render, staticRenderFns } from "./EditPackagingDialog.vue?vue&type=template&id=7c2d7fa0&scoped=true"
import script from "./EditPackagingDialog.vue?vue&type=script&lang=js"
export * from "./EditPackagingDialog.vue?vue&type=script&lang=js"
import style0 from "./EditPackagingDialog.vue?vue&type=style&index=0&id=7c2d7fa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2d7fa0",
  null
  
)

export default component.exports